import { createInput } from '@formkit/vue'
import { es } from '@formkit/i18n'
import { createProPlugin, inputs } from '@formkit/pro'
import { rootClasses } from './formkit.theme'
import CityAutocomplete from '@/components/CityAutocomplete.vue'
import InputTelefono from '@/components/InputTelefono.vue'
import SelectPaises from '@/components/SelectPaises.vue'
import AudioUpload from '@/components/formkit/AudioUpload.vue'
import WordCountTextarea from '@/components/formkit/WordCountTextarea.vue'
import Phone from '@/components/formkit/Phone.vue'
import AvatarUpload from '@/components/formkit/AvatarUpload.vue'
const pro = createProPlugin('fk-88153e75989', inputs)

const config = {
  locales: { es },
  locale: 'es',
  plugins: [pro],
  config: {
    rootClasses,
  },
  inputs: {
    'ciudad': createInput(CityAutocomplete),
    'telefono': createInput(InputTelefono),
    'pais': createInput(SelectPaises),
    'wctextarea': createInput(WordCountTextarea),
    'audio_orsai': createInput(AudioUpload),
    'phone': createInput(Phone),
    'avatar': createInput(AvatarUpload),
  },
  messages: {
    es: {
      ui: {
        incomplete: 'Disculpe, los campos no fueron completados correctamente',
      }
    }
  }
}

export default config
